module.exports = __webpack_public_path__ + "img/1.c79180d5.png";